module.exports = __webpack_public_path__ + "img/map_close.42cf22a6.svg";